"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("../../utils/styled-components"));
var Chat32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("defs", null,
        react_1.default.createElement("path", { d: "M22.008 13.502c0-.084.081-.264.347-.39.267-.126.458-.073.52-.022l-.868-.721.001 1.133zm.867-.412c-.062-.051-.253-.104-.52.022-.266.126-.347.306-.347.39v-1.133l.867.72zM22.99 0A2.997 2.997 0 0126 2.999v6.009a2.996 2.996 0 01-2.993 2.999v.999l.001.495c0 .543-.345.713-.772.358l-2.23-1.852-.006-.005v4a3.001 3.001 0 01-2.998 3.005H7.005L4.714 21.37c-.382.394-.692.26-.691-.294v-1.069l.001-1h-.999A3.009 3.009 0 010 16.002V8.005A3.001 3.001 0 012.994 5H10V2.999A3.004 3.004 0 0113.01 0h9.98zm-5.985 6H2.994A2.001 2.001 0 001 8.005v7.997c0 1.109.898 2.005 2.009 2.005h1.015a1 1 0 011 1v.607l1.263-1.303a1 1 0 01.718-.304h9.997A2.001 2.001 0 0019 16.002V8.005C19 6.895 18.107 6 17.006 6zm5.985-5h-9.982C11.9 1 11 1.896 11 2.999V5h6.006A2.998 2.998 0 0120 8.005v3.002a.996.996 0 01.645.23l1.362 1.132v-.362a1 1 0 011-1c1.1 0 1.993-.895 1.993-2V3A1.997 1.997 0 0022.99 1z", id: "chat-32_svg__a" })),
    react_1.default.createElement("g", { transform: "translate(3 6)", fill: "currentColor", fillRule: "evenodd" },
        react_1.default.createElement("mask", { id: "chat-32_svg__b" },
            react_1.default.createElement("use", { xlinkHref: "#chat-32_svg__a" })),
        react_1.default.createElement("use", { fillRule: "nonzero", xlinkHref: "#chat-32_svg__a" }),
        react_1.default.createElement("g", { mask: "url(#chat-32_svg__b)" },
            react_1.default.createElement("path", { d: "M-3-6h32v32H-3z" }))))); };
var StyledChat32 = styled_components_1.default(Chat32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledChat32;
var templateObject_1;
//# sourceMappingURL=Chat32.js.map